const login = {
  login: 'Entrar',
  phone: 'Celular',
  email: 'E-mail',
  erCode: 'Código QR',
  phoneNo: 'Número de Celular',
  sryx: 'Por favor, insira o e-mail',
  password: 'Senha',
  wjmm: 'Esqueceu a senha?',
  srmm: 'Por favor, insira a senha',
  myzh: 'Ainda não tem uma conta?',
  ljzc: 'Registrar Agora',
  cxsm: 'Atualize e use novamente o aplicativo Biking para escanear o código QR',
  xydl: 'Por favor, responda ao login em seu celular',
  smewm: 'No aplicativo Biking, clique no ícone do perfil e depois no ícone no canto superior direito para escanear o código QR',
  qtfs: 'Outras opções de login',
  ggsfyz: 'Verificação de identidade do Google',
  bdsj: 'Você já vinculou o número de celular',
  bdyx: 'Você já vinculou o e-mail',
  fsyzm: 'Enviar Código de Verificação',
  wcyz: 'Por favor, conclua a verificação',
  dlcg: 'Você fez login com sucesso, bem-vindo(a) à Biking!',
  bktb: 'Por motivos de segurança, a retirada não estará disponível por 24 hora após a modificação das configurações de segurança da conta.',
  fhdl: 'Voltar para a página de login',
  jx: 'Continuar',
  cxfs: 'Reenviar',
  gxmm: 'Atualizar senha',
  srsjh: 'Por favor, insira o número de celular',
  wjmm1: 'Esqueceu a senha',
  sryxdz: 'Por favor, insira o endereço de e-mail',
  srzqyx: 'Por favor, insira um endereço de e-mail válido',
  sryzm: 'Digite o código de verificação',
  czmm: 'Redefinir senha',
  sbdyzm: 'Não recebeu o código de verificação?',
  srxmm: 'Digite a nova senha',
  zczh: 'Criar uma conta Biking',
  yqm: 'Código de Convite (opcional)',
  sryqm: 'Por favor, insira o código de convite',
  zc: 'Registrar',
  yyzh: 'Já tem uma conta?',
  ljdl: 'Faça login agora',
  fsz: 'O código de verificação foi enviado para',
  next: 'Próximo',
  szmm: 'Definir senha',
  submit: 'Enviar',
  zccg: 'Registro bem-sucedido!'
};

const download = {
  title: 'Plataforma de jogos diversificados e<br/>negociação de criptomoedas',
  subTitle: 'Biking suporta a negociação de mais de cem criptomoedas',
  xzbw: 'Por que escolher Biking',
  czzz: 'BiKing ajuda a criar, valorizar e preservar sua riqueza',
  download: 'Baixar na App Store',
  downloadtf: 'Baixar via TestFlight',
  cjqxz: 'Baixar o SuperAssinatura',
  cjq: 'SuperAssinatura {index}',
  bdxz: 'Baixar Localmente',
  ggpxz: 'Baixar na Google Play',
  advantageTitle1: 'Alto Desempenho · Negociação Rápida',
  subTitleSubTitle1: 'Tecnologia da Bolsa de Valores de Londres, baixa latência, negociação rápida',
  advantageTitle2: 'Proteção de Ativos · Segurança Extrema',
  subTitleSubTitle2: 'Biking está em conformidade com o padrão CCSS para garantir a segurança dos ativos e dados',
  advantageTitle3: 'Serviço 24 horas por dia',
  subTitleSubTitle3: 'Garantia de funcionamento normal do sistema e atendimento ao cliente 24 horas por dia',
  qhidxq: 'Alternar detalhes do ID',
  step1: 'Passo 1',
  step2: 'Passo 2',
  step3: 'Passo 3',
  step4: 'Passo 4',
  step5: 'Passo 5',
  step6: 'Passo 6',
  step7: 'Passo 7',
  step8: 'Passo 8',
  step9: 'Passo 9',
  step10: 'Passo 10',
  azBiking: 'Instalar o Biking através do App Store',
  dlxz: 'Se você possui um ID Apple fora da China continental, faça o download diretamente no App Store',
  fdlid: 'Prepare um ID Apple fora da China continental',
  yxfshq: 'Se você não tem um ID Apple fora da China continental, pode tentar obter um da seguinte forma',
  qhid: 'Alternar Apple ID no App Store',
  dk: '1. Abra o aplicativo',
  ysjtx: 'App Store, clique no ícone de perfil no canto superior direito da App Store',
  cxsrmm: '2. Clique em sair e faça login novamente com seu Apple ID e senha',
  wfdl: '* Se for exibida a mensagem "Não é possível fazer login", pode ser devido a um número alto de alterações de login recentes. Tente substituir o ID ou tente novamente algumas horas depois. Se o ID estiver bloqueado, será necessário verificar ou substituir o ID para tentar novamente',
  azapp: 'Instalar o aplicativo',
  storesh: '1. Após o login bem-sucedido, você será redirecionado automaticamente para a App Store da região correspondente. Pesquise "Biking" na App Store e clique no botão "Obter" para começar a instalar o aplicativo',
  jxxz: 'Eu tenho um ID Apple fora da China continental, continue o download',
  jxxz1: 'Continuar download',
  way1: 'Método 1',
  wayTitle1: 'Registrar-se por conta própria, seguro e estável',
  wayBtn1: 'Ver como registrar',
  way2: 'Método 2',
  wayTitle2: 'ID de referência da plataforma (conveniente e rápido)',
  wayBtn2: 'Ver ID de referência',
  way3: 'Método 3',
  wayTitle3: 'Guia de países/regiões (alternância livre)',
  wayBtn3: 'Ver como comprar',

  ckzh: 'Contas de referência para ID Apple fora da China continental',
  jgck: 'As IDs abaixo estão disponíveis para referência em outras regiões',
  jjfz: '(Clique nas contas ou senhas para copiar diretamente)',
  zh: 'Conta',
  mm: 'Senha',
  xxxl: 'Para evitar o vazamento de informações do seu celular',
  dlicloud: 'não use o ID Apple acima para fazer login no iCloud',
  tczh: 'Após usar a ID Apple de referência para baixar o aplicativo, saia da conta imediatamente',
  cfsy: 'Não vincule o número de celular, caso contrário, a ID não poderá ser reutilizada',
  jrql: 'Escanee o código QR para entrar no grupo',
  lxkf: 'Contate o serviço de atendimento ao cliente',

  zjzc: 'Registrar um ID Apple estrangeiro',
  registerStep1: 'Passo 1 Abrir a página inicial do Apple ID',
  registerStep2: 'Passo 2 Verificar o e-mail',
  registerStep3: 'Passo 3 Sair da conta da App Store',
  registerStep4: 'Passo 4 Fazer login na App Store com o ID recém-registrado',
  gwzcwz: 'Abra o navegador Safari e acesse o site oficial de registro da Apple:',
  yzdzyx: 'Preencha todas as informações e clique em "Continuar". Você receberá um e-mail de verificação do Apple ID; insira o código de verificação recebido.',
  tjfkfs: 'Em seguida, você será redirecionado automaticamente para a página de gerenciamento do Apple ID (pode levar um tempo para carregar). No gerenciamento, clique em "Pagamento e Entrega" e, em seguida, clique em "Adicionar Método de Pagamento".',
  mgsfzsc: 'Agora vem a parte mais importante: verifique se o método de pagamento é "Nenhum" e, caso seja, não o altere. Verifique também se o país ou região está definido como "Estados Unidos" ou o país/região onde você deseja registrar o ID. O restante das informações pode ser preenchido de forma aleatória, mas é melhor usar o inglês e selecionar "Alasca" como estado/província, pois esta região permite compras isentas de impostos na App Store. As informações pessoais podem ser geradas através do site: Gerador de ID dos EUA',
  gxdqxx: 'Após preencher as informações, clique em "Atualizar" para atualizar as informações de região.',
  zhxx: '1. Acesse a App Store e clique no ícone de perfil no canto superior direito para entrar na página da conta.',
  djwc: '2. Role a página para baixo e clique em "Sair" para sair da conta da App Store e, em seguida, clique em "Concluir".',
  jrzhdl: '1. Clique novamente no ícone de perfil no canto superior direito para acessar a página de login da conta.',
  zhmmdl: '2. Insira a conta e a senha e clique em "Login" para fazer o login.',
  jydlcg: '3. Insira o código de verificação e, após a verificação bem-sucedida, você será conectado ao Apple ID com sucesso.',
  jysssd: 'Negocie a qualquer hora e em qualquer lugar',
  smewm: 'Escanear o código QR',
  xiazai: 'Baixar',
  huodong: 'Eventos',
  title1: 'Plataforma de jogos diversificados',
  title2: 'e de negociação de criptomoedas da Biking',
  open: 'Abrir no aplicativo "Biking"',
  ggzx: 'Centro de Avisos',
  lscb: 'Depósito em Blockchain',
  fbrj: 'Depósito de Moeda Fiduciária',
  tgaq: 'Compromisso em fornecer um serviço mais seguro para os usuários',
  wdjmzc: 'Serviço estável de negociação de derivativos de ativos criptográficos',
  szhbjy: 'Somos especialistas em negociação de criptomoedas',
  yxhsjh: 'Registre-se com e-mail/número de celular'
};

export { login, download };



// WEBPACK FOOTER //
// ./src/i18n/lang/login/pt_BR.js